module.exports = __webpack_public_path__ + "static/img/gaozhongdili9.12cb6fb8.jpg";